import React from 'react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { situations } from '../../data/salesCopy';
export function SituationsSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-300" data-mp="3lf8c436lz6dm">
      <SectionHeader tone="dark" eyebrow="Does any of this sound familiar?" title="If You Recognize These Situations, This Collection Was Designed With Your Learning Needs in Mind." data-id="element-301" data-mp="3lcvuxs8od01m" />

      <ol className="mx-auto mt-12 grid max-w-6xl gap-x-12 md:grid-cols-2" data-id="element-302" data-mp="3gfnblobsipys">
        {situations.map((s, i) => <li key={s.title} className="flex gap-5 border-t border-white/10 py-7" data-id="element-303" data-mp="32gdummfrfrtr" data-mpi={i}>
            <span className="font-display text-5xl font-black leading-none text-flame" data-id="element-304" data-mp="37exkgxxh5nre">{i + 1}</span>
            <div data-id="element-305" data-mp="10ohibalrqdxx">
              <h3 className="font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-306" data-mp="10nzd3oh4opdv">{s.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-slate-300" data-id="element-307" data-mp="15mj2xzyuelbi">{s.body}</p>
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-brand p-7 text-center sm:p-10" data-id="element-308" data-mp="295kbfiluhaoc">
        <p className="text-balance font-display text-3xl font-black uppercase leading-tight text-navy-950 sm:text-4xl" data-id="element-309" data-mp="248bu1k8itao5">
          You Don’t Have to Keep Every Assessment Detail in Your Head.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-navy-900" data-id="element-310" data-mp="2e0hulicu90ey">
          I organized these educational resources to help you review the assessment process, document relevant findings, and approach clinical
          reasoning with greater structure.
        </p>
      </div>

      <CtaButton tone="dark" label="Get the Complete Blueprint for $27" sub="One-time payment · Instant access · 7-day guarantee" data-id="element-311" data-mp="1zaacx4unnlfb" />
    </section>;
}